'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$76(evaluator$38) {
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$76__f_evaluator$14 = null;
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$76__f_evaluator$14 = evaluator$38;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$76 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$76 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$76.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$76.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$76;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$76() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$76 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$76 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$76.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$76.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$76.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$76.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_GeneralPracticeAppUpdate$$anon$76__f_evaluator$14.apply__O();
  return ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Ljkugiya_ulid_ULID) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$76.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$76 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$76, "app.api.GeneralPracticeAppUpdate$$anon$76", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$76: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$76 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$76 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$76.js.map
